import { MEMBER_TABLE_VIEWS_ARRAY, MEMBER_TABLE_VIEWS } from '@constants/members';
import { ToggleOptionsButton } from 'components/ToggleOptionsButton';
import { ComponentProps, useCallback } from 'react';
import { TeamsOverviewContainer } from '../TeamOverview/TeamsOverviewContainer';
import { TeamMembersTableContainer } from '../TeamMembersTable/TeamMembersTableContainer';
import { MinimalCard } from 'components/styled';
import { useParams, useSearchParams } from 'react-router-dom';
import useAppNavigation from 'hooks/useAppNavigation';
import { TeamUtilizationContainer } from '../TeamUtilization/TeamUtilizationContainer';
import { TeamActivityLogTab } from '../TeamActivityLogTab';
import RecentLoginsTab from 'GrafanaModule/components/RecentLoginsTab';
import SuppressedEmailsTab from './SuppressedEmailsTab';

const ComponentByView = {
  [MEMBER_TABLE_VIEWS.OVERVIEW]: TeamsOverviewContainer,
  [MEMBER_TABLE_VIEWS.UTILIZATION]: TeamUtilizationContainer,
  [MEMBER_TABLE_VIEWS.ALL_MEMBERS]: TeamMembersTableContainer,
  [MEMBER_TABLE_VIEWS.ACTIVITY_LOG]: TeamActivityLogTab,
  [MEMBER_TABLE_VIEWS.RECENT_LOGINS]: RecentLoginsTab,
  [MEMBER_TABLE_VIEWS.SUPPRESSED_EMAILS]: SuppressedEmailsTab,
};

export const TeamInfoSectionContainer: React.FC<{
  teamId: number;
  isFetchingTeamMembers: boolean;
  isContextReady?: boolean;
}> = ({ teamId, isFetchingTeamMembers, isContextReady }) => {
  const { memberTableView } = useParams<{ memberTableView: string; teamId: string }>();
  const [searchParams] = useSearchParams();
  const { navigateToTeamProfile } = useAppNavigation();
  const Component = memberTableView ? ComponentByView[memberTableView] : undefined;

  // Get tenant/realmId from URL to maintain context when switching views
  const urlTenant = searchParams.get('tenant') || undefined;
  const urlRealmId = searchParams.get('realmId') || undefined;

  const onViewToggle: ComponentProps<typeof ToggleOptionsButton>['onSelect'] = useCallback(
    ({
      option,
    }: Parameters<NonNullable<ComponentProps<typeof ToggleOptionsButton>['onSelect']>>[0]) => {
      navigateToTeamProfile({
        teamId,
        memberTableView: option.value as string,
        tenant: urlTenant,
        realmId: urlRealmId,
      });
    },
    [navigateToTeamProfile, teamId, urlTenant, urlRealmId],
  );

  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 6, padding: 4 }}>
      <ToggleOptionsButton
        options={MEMBER_TABLE_VIEWS_ARRAY}
        currentOption={memberTableView || ''}
        onSelect={onViewToggle}
      />
      {Component && (
        <Component
          teamId={teamId}
          isFetchingTeamMembers={isFetchingTeamMembers}
          isContextReady={isContextReady}
          tenant={urlTenant}
          realmId={urlRealmId}
        />
      )}
    </MinimalCard>
  );
};
